module.exports = __webpack_public_path__ + "static/media/outline-extra-thick.88e8357d.png";